import { FeatureFlag } from 'app/types'
import { waitForSelectorValue } from 'app/state/storeUtils'
import { getStore } from 'app/state/storeRegistry'
import { getFeatureFlag, launchDarklyFeatureFlagsReady } from 'features/common/state/commonSlice'
import { setAgentConfig, setAgentEnabledForViewer } from 'features/maps/state/mapsSlice'
import { AISettings } from 'features/builder/types'
import { updateAISettings } from '../state/builderSlice'

export async function migrateGenAiToAgent() {
  try {
    const featureFlagsLoaded = await waitForSelectorValue(launchDarklyFeatureFlagsReady, true)
      .then(() => true)
      .catch(() => false)

    if (!featureFlagsLoaded) {
      console.warn('migrateDocumentModeLayers: failed waiting for feature flags, skipping')
      return
    }

    const store = getStore()
    const state = store.getState()

    const genAIV1FeatureFlag = getFeatureFlag(state, FeatureFlag.GenAIV1)

    if (!genAIV1FeatureFlag) return

    const genAiSettings: AISettings = state.builder.aiSettings
    const agent = state.maps.currentMap?.agent
    const mapTitle = state.maps.currentMap?.title

    // Skip migration if GenAI not enabled or configured, or if already migrated. [sc-505727]
    if (!genAiSettings || genAiSettings.migratedAt || !genAiSettings.enabled) return

    // If there's already an agent config, there's no need to migrate
    if (agent?.config) return

    store.dispatch(setAgentEnabledForViewer(genAiSettings.enabled))
    store.dispatch(
      setAgentConfig({
        useCase: mapTitle
          ? `Assist users in extracting insights from ${mapTitle} map.`
          : 'Assist users in extracting insights from the map.',
        instructions: genAiSettings.mapContext,
        tools: [],
        capabilities: { querySources: false, showDetails: false },
        introduction: { welcome: genAiSettings.userGuide, starters: genAiSettings.conversationStarters }
      })
    )
    store.dispatch(updateAISettings({ migratedAt: new Date().toISOString() }))
  } catch (error) {
    console.error('Error migrating GenAI to Agent', error)
  }
}
